import React, { useState } from 'react';
import Button from '@techsoftware/happay-widgets/Button';
import Icons from '@techsoftware/happay-widgets/FontIcon';
import Popup from '@techsoftware/happay-widgets/Popup';
import history from '../../utils/history';

const DynamicButtons = ({ buttonsArr = [], fromPage = '', id = "" }) => {
  const [showBulkAdditionBtn, setShowBulkAdditionBtn] = useState(false);
  const handleBulkOption = event => {
    event.stopPropagation();
    setShowBulkAdditionBtn(true);
    setTimeout(() => {
      const ele = document.getElementById('vendor-bulk-button');
      if (ele) {
        ele.focus();
      }
    }, 0);
  };
  const handleBulkDetails = () => {
    history.push('/vendor/myvendor/bulkcreateview');
  };
  const noContentVendorBtn = fromPage === 'NoContent';
  const buttonsUI = buttonsArr.map(
    ({
      text = '',
      variant = 'secondary',
      action = () => {},
      iconType = '',
    }, i) => {
      const vendorBtn = text.includes('Vendor');
      return (
        text && (
          <div id={`${id}-${i}`} className="flex-horizontal-center margin-l-20">
            <Button
              type="button"
              text={text}
              id={text}
              variant={variant}
              // className={!noContentVendorBtn ? 'margin-l-20' : ''}
              onClick={action}
              startIcon={iconType}
              buttonParentStyles={{
                padding: vendorBtn ? '10px 12px 10px 24px' : '10px 24px',
                borderTopRightRadius: vendorBtn && '0px',
                borderBottomRightRadius: vendorBtn && '0px',
                height: '40px',
                // display: 'flex',
                // justifyContent: 'center',
                // alignItems: 'center',
              }}
            />{' '}
            {vendorBtn && (
              <Button
                type="button"
                text={<Icons type="dropdown" />}
                variant="primary"
                className="height-40"
                onClick={handleBulkOption}
                buttonParentStyles={{
                  // padding: noContentVendorBtn ? '8.3px 9px' : '8.2px 9px',
                  padding: '8px',
                  // position: noContentVendorBtn ? 'absolute' : '',
                  borderTopLeftRadius: '0px',
                  borderBottomLeftRadius: '0px',
                  height: '40px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderLeft: '1px solid #E8DFF2',
                }}
                id={
                  noContentVendorBtn
                    ? 'no-bulk-vendor-parent'
                    : 'bulk-vendor-parent'
                }
              />
            )}
            <Popup
              id="top-right"
              parentElementId={
                noContentVendorBtn
                  ? 'no-bulk-vendor-parent'
                  : 'bulk-vendor-parent'
              }
              open={showBulkAdditionBtn}
              className="height-40"
              pointerPlacement="top-right"
              onClose={() => setShowBulkAdditionBtn(false)}
              backgroundColor="#8dc5a8"
              pointerStyle={{ display: 'none' }}
              popupStyle={{
                right: noContentVendorBtn ? '550px' : '50px',
                left: 'unset !important',
                boxShadow: '0 1px 4px 0px #00000029',
              }}
            >
              <Button
                type="button"
                id="vendor-bulk-button"
                text={'Bulk Vendor Addition'}
                variant="secondary"
                onClick={handleBulkDetails}
                buttonParentStyles={{
                  // background: '#f3eff8',
                  height: '40px',
                  color: '#3c424e',
                  borderColor: '#f3eff8',
                }}
                className={'fw-500'}
                size={'small'}
              />
            </Popup>
          </div>
        )
      );
    },
  );
  return <>{buttonsUI}</>;
};

export default DynamicButtons;
